import styles from './slotMachineGame.module.css';

import SlotMachineGameLetters from './SlotMachineGameLetters';

export default function SlotMachineGame({
  place,
  prize,
  email,
  isWinner,
  currentWinnerIndex,
  fetchData,
  winCondition,
  setIsWinnerGenerated,
  setCurrentWinnerIndex,
  setWinCondition,
  direction,
  totalPrizes,
  showPlace = true,
}) {
  return (
    <>
      <div className={styles.SlotMachineGameWrapper}>
        <div
          className={`${styles.SlotMachineGamePrizeText1} ${styles.marquee}`}
        >
          <div>
            {showPlace && (
              <span className={styles.SlotMachineGamePrizeText2Place}>
                {place}
              </span>
            )}
            <span className={styles.SlotMachineGamePrizeText2}>{prize}</span>
          </div>
        </div>
        <h2
          className={styles.SlotMachineGameUserEmailText}
          style={{ opacity: isWinner === 1 ? 1 : 0 }}
        >
          {email}
        </h2>
      </div>
      <SlotMachineGameLetters
        fetchData={fetchData}
        winCondition={winCondition}
        setIsWinnerGenerated={setIsWinnerGenerated}
        setCurrentWinnerIndex={setCurrentWinnerIndex}
        currentWinnerIndex={currentWinnerIndex}
        setWinCondition={setWinCondition}
        direction={direction}
        totalPrizes={totalPrizes}
      />
    </>
  );
}
